import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import Agent from '../agent';

const initialState = {
  loading: false,
  networks: [],
  errors: {},
  success: false,
  message: '',
};

// These are redux/toolkit async thunk for performing api call
// There methods are automatically attached to reducers and actions below
export const getNetwork = createAsyncThunk('network/get', async (payload, { rejectWithValue }) => {
  try {
    const { data } = await Agent.Network.get();
    return data;
  } catch (err) {
    let error = err;
    if (!error.response) {
      return rejectWithValue({ errors: { [err.name]: err.message } });
    }
    return rejectWithValue(error.response.body);
  }
});

export const updateNetwork = createAsyncThunk(
  'network/update',
  async (data, { rejectWithValue }) => {
    try {
      return await (
        await Agent.Network.update(data)
      ).data;
    } catch (err) {
      let error = err;
      if (!error.response) {
        return rejectWithValue({ errors: { [err.name]: err.message } });
      }
      return rejectWithValue(error.response.body);
    }
  }
);

const networkSlice = createSlice({
  name: 'network',
  initialState,
  reducers: {
    setChainSelection(state, action) {
      state.networks = state.networks.map((network) => {
        if (network.id === action.payload) {
          return { ...network, selected: !network.selected };
        } else {
          return network;
        }
      });
    },
    setChainSelectionAll(state) {
      if (state.networks.findIndex((network) => !network.selected) > -1) {
        state.networks = state.networks.map((network) => ({ ...network, selected: true }));
      } else {
        state.networks = state.networks.map((network) => {
          if (network.disabled) {
            return network;
          } else {
            return { ...network, selected: false };
          }
        });
      }
    },
  },
  extraReducers: {
    // these are the actions generated by the above createAsyncThunk of redux/toolkit
    // get all network chain list
    [getNetwork.pending]: (state) => {
      state.loading = true;
      state.success = false;
    },

    [getNetwork.fulfilled]: (state, action) => {
      state.networks = action?.payload?.data || {};
      state.loading = false;
      state.success = true;
    },

    [getNetwork.rejected]: (state, action) => {
      state.loading = false;
      state.success = false;
      state.errors = action?.payload?.errors || {};
    },

    // update network chain list
    [updateNetwork.pending]: (state) => {
      state.loading = true;
      state.success = false;
    },

    [updateNetwork.fulfilled]: (state, action) => {
      state.loading = false;
      state.success = true;
      state.message = 'Network chain list successfully updated';
    },

    [updateNetwork.rejected]: (state, action) => {
      state.loading = false;
      state.success = false;
      state.errors = action?.payload?.errors || {};
    },
  },
});

export const networkSelector = (state) => state.network;

export const { reducer, actions } = networkSlice;
